// export const COLOR_ARRAY = [
// 	'#e1be0f',
// 	'#b399ff',
// 	'#a2e383',
// 	'#e2b5ea',
// 	'#cfdd1c',
// 	'#6ec1e4',
// 	'#8bd8b2',
// 	'#ff7fb4',
// 	'#fab768',
// 	'#e27272',
// 	'#a19090',
// 	'#016193',
// ];

export const COLOR_ARRAY = [
	'#9ec2d5', // голубой
	'#959595', // темно-серый
	'#9dc948', // зеленый
	'#016193', // синий
	'#ffcb00', // желтый
	'#d5d5d5', // светло-серый
	'#9a4db8', // фиолетовый
	'#fea6a6', // розовый
	'#fab768', // оранжевый
	'#e27272', // красный
	'#a19090', // коричневый
	'#f5a623', // оранжевый
	'#016193', // синий
];

export const MONTH_ARRAY = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const SCALE_COEFFICIENT_MAX = 0.1;
export const SCALE_COEFFICIENT_MIN = 0.12;
